import { Outlet } from "react-router-dom";
import { useMeQuery } from "@shared/api";
import { API_BASE_URL } from "@shared/config";
import { useSyncTableUserPreferencesFromServer } from "@shared/hooks";
import { useHydrateAccountPreferences } from "@i18n/hooks/useHydrateAccountPreferences";
import { UserContext } from "./userContext.definition";

export const UserContextProvider = () => {
  const { data: user = null } = useMeQuery({
    staleTime: 5 * 60 * 1000,
  });

  useSyncTableUserPreferencesFromServer(user?.userPreferences);
  useHydrateAccountPreferences(user);

  const logout = () => {
    window.location.href = `${API_BASE_URL}/v1/auth/logout`;
  };

  return (
    <UserContext.Provider value={{ user, permissions: [], logout }}>
      <Outlet />
    </UserContext.Provider>
  );
};
